import {Component, Input, ElementRef, AfterViewInit, OnInit} from '@angular/core';
import {OptionService} from 'option/option.service';
import {ElementService} from 'service/element.service';
import {FormControl} from "@angular/forms";

/**
 * Componenet for the salutation in the contact form.
 */
@Component({
  selector: 'salutation',
  templateUrl: './input.salutation.component.html',
})

/**
 * Component for the salutation of the contact form.
 */
export class InputSalutationComponent implements AfterViewInit, OnInit {
  /**
   * the form
   */
  @Input() form: any;

  /**
   * contact element for saving the data
   */
  @Input() contact: any;

  /**
   * warpper classes for the element.
   */
  @Input() wrapperClass: string;

  /**
   * toggle to scroll after showing the component.
   */
  @Input() scrollOnReveal = false;

  /**
   * A boolean variable indicating whether the inputs are disabled.
   */
  @Input() disabled = false;

  /**
   * form element from the contact form.
   */
  formElement: FormControl;

  /**
   * holds all mandatory contact fields.
   */
  mandatoryFields: any;

  /**
   * flag to show the divser salutation.
   */
  hasSalutationDivers = false;

  /**
   * flag to show the other salutation.
   */
  hasSalutationOther = false;

  /**
   * width of the columns
   */
  columnWidth = 6;

  /**
   * value of the other salutation
   */
  salutationOtherValue = '';

  /**
   * the constructor
   * @param optionService
   * @param elementService
   * @param el
   */
  constructor(protected optionService: OptionService, protected elementService: ElementService, private el: ElementRef) {
    // get mandatory fields and set validators
    this.mandatoryFields = this.optionService.getOption('mandatory_contact_fields').split(",");

    // Initialize salutation options and column width
    this.hasSalutationDivers = this.optionService.getOrganisationData('has_salutation_divers');
    this.hasSalutationOther = this.optionService.getOrganisationData('has_salutation_other');
    this.salutationOtherValue = this.optionService.getOrganisationData('salutation_other_value');

    // Set column width based on salutation options
    if (this.hasSalutationDivers || this.hasSalutationOther) {
      this.columnWidth = this.hasSalutationDivers && this.hasSalutationOther ? 3 : 4;
    }
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.formElement = this.form.get('salutation');
  }

  /**
   * After view init
   */
  ngAfterViewInit() {
    if (this.scrollOnReveal) {
      // scroll to component
      const component = this.el.nativeElement;
      this.elementService.scrollToElement(component);
    }
  }

  /**
   * Returns if salutation is mandatory.
   */
  isSalutationMandatory(): boolean {
    return this.mandatoryFields.indexOf('salutation') !== -1;
  }
}
